// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Zelda Universe - Aliens Configuration
 * 
 * IMPORTANT: This file only contains the planet-to-alien mapping.
 * All alien definitions are in src/config/AlienSpeciesConfig.js
 * 
 * Workflow:
 * 1. Add alien to AlienSpeciesConfig.js first
 * 2. Then map it to planets here
 */

export const ZeldaAliensPlanets = {
  planets: {
    // Hyrule Kingdom (1200) - Central hub with heroes
    1200: ['link', 'zelda', 'impa', 'epona'],
    
    // Kakariko Village (1201) - Sheikah settlement
    1201: ['impa', 'navi'],
    
    // Lon Lon Ranch (1202) - Pastoral farmland
    1202: ['epona', 'navi'],
    
    // Lost Woods (1203) - Mystical forest
    1203: ['navi', 'korok'],
    
    // Death Mountain (1204) - Goron homeland
    1204: ['goron'],
    
    // Zora's Domain (1205) - Aquatic realm
    1205: ['zora'],
    
    // Rito Village (1206) - Sky settlement
    1206: ['rito'],
    
    // Korok Forest (1207) - Forest spirit sanctuary
    1207: ['korok', 'navi'],
    
    // Dark World (1208) - Ganondorf's domain
    1208: ['ganondorf', 'bokoblin'],
    
    // Cursed Lands (1209) - Corrupted wasteland
    1209: ['bokoblin', 'guardian']
  },
  
  // Random encounter aliens (for space travel events)
  randomEncounters: [
    'navi',
    'korok',
    'epona',
    'impa'
  ],
  
  // Hostile species that may attack on sight
  hostileSpecies: [
    'ganondorf',
    'bokoblin',
    'guardian'
  ],
  
  // Friendly traders willing to do business
  friendlyTraders: [
    'goron',
    'zora',
    'rito',
    'korok'
  ]
};
